import { connect } from 'react-redux'
import { compose } from 'recompose'

import providesUserPresence from 'components/Notes/dataSync/providesUserPresence'
import { getViewState } from 'data'
import { currentUserCanEditNote } from 'data/rights/selectors'
import { selectors as NotesSelectors } from 'data/notes'
import { selectors as UISelectors } from 'data/ui'
import { selectors as ChannelsSelectors } from 'data/channels'
import { getChannelLabel } from 'data/channels/helpers'
import syncNote from 'components/Notes/dataSync'
import { NOTE_VIEW } from 'components/viewNames'
import { connectToDoc } from '@slite/editor'
import {
  isOnboardingActive,
  isOwnerOnboardingActive,
  isOnboardingOnInviteStep,
} from 'screens/OnboardingPopover/utils'
import withRouterActions from 'routes/utils/withRouterActions'

const types = {
  RichText: 'rich-text',
  JSON1: 'json1',
}

const mapStateToProps = (state, { noteId, threadId }) => {
  const note = NotesSelectors.getNote(state, noteId)
  const noteTitle = note && note.get('title')
  const noteOtType = note && note.get('otType')
  const channelId = note && note.channelId
  const channel = ChannelsSelectors.getChannel(state, channelId)
  const channelLabel = getChannelLabel(channel)
  const isDirectEditingNote = UISelectors.isDirectEditingNote(state)
  const noteIsLockedForEdition = NotesSelectors.isLockedForEdition(
    state,
    noteId
  )

  const hideForOwnerOnboarding =
    isOwnerOnboardingActive(state) && isOnboardingOnInviteStep(state)
  const hideForJoinerOnboarding =
    isOnboardingActive(state) && !isOwnerOnboardingActive(state)

  return {
    showLoadingPlaceholder:
      hideForOwnerOnboarding ||
      hideForJoinerOnboarding ||
      !note ||
      getViewState(state, NOTE_VIEW).pristine,
    errors: getViewState(state, NOTE_VIEW).errors,
    noteId,
    channelId,
    noteTitle,
    noteOtType,
    channelLabel,
    threadId,
    isDirectEditingNote,
    noteIsLockedForEdition,
    userCanEditNote: currentUserCanEditNote(state, note),
  }
}

export default compose(
  providesUserPresence(),
  syncNote({ viewName: NOTE_VIEW, track: true }),
  withRouterActions,
  connect(mapStateToProps),
  connectToDoc(({ noteId, noteOtType }) => ({
    id: noteId,
    collection: 'notes',
    type: types[noteOtType],
  }))
)
